import React from 'react';
import { companyLogos } from '../mock';

const CompanyLogos = () => {
  const items = [...companyLogos, ...companyLogos];
  return (
    <section className="py-14 md:py-16 border-y border-[#143324]/10 bg-paper-soft overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 mb-8 text-center">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#3d3d3d] font-body">
          Our graduates work at top firms
        </p>
      </div>
      <div className="relative">
        <div className="flex whitespace-nowrap animate-marquee-slow items-center">
          {items.map((src, i) => (
            <div key={i} className="flex items-center justify-center px-10 shrink-0 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all">
              <img src={src} alt="company logo" className="h-10 md:h-12 object-contain" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyLogos;
